export enum BackorderLogic {
  ORIGINAL = 'ORIGINAL',
  STOCK_ONLY = 'STOCK_ONLY',
}
